import type { DailyActionType, UserDailyStatsResponseDTO } from 'app/network/daily-stats';

/**
 * Dev-only fake data to iterate on streak UI (4-day window, missed slot, etc.).
 * Toggle `STREAK_DEV_MOCK_ENABLED` to true while testing, then set back to false before shipping.
 */
export const STREAK_DEV_MOCK_ENABLED = false;

export const STREAK_MOCK_TOTAL_DAYS = 7;

export interface StreakDevMockScenario {
  numStreak: number;
  todayActionDate: string;
  completedDaySlots: number[];
  missedDaySlots: number[];
  currentDaySlot: number;
  actionTypes: DailyActionType[];
}

/**
 * Scenario: J1 ✓, J2 missed ✗, J3 ✓, J4 = today pending (🧊 if warning path).
 * Adjust slots freely for other prototypes.
 */
export const STREAK_DEV_MOCK_SCENARIO_DEFAULT: StreakDevMockScenario = {
  numStreak: 2,
  todayActionDate: '', // no action yet today → header/widget muted until contrib
  completedDaySlots: [1, 3],
  missedDaySlots: [2],
  currentDaySlot: 4,
  actionTypes: ['publish_offer', 'send_message'],
};

export function buildStreakDevMockStats(scenario: StreakDevMockScenario): UserDailyStatsResponseDTO {
  const actions =
    scenario.todayActionDate.length > 0
      ? [
          {
            id: 'mock-action',
            userId: 'mock',
            date: scenario.todayActionDate,
            action: 'publish_offer' as const,
            createdAt: new Date().toISOString(),
          },
        ]
      : [];

  return {
    actions,
    actionTypes: scenario.actionTypes,
  };
}
